import WarehouseServices from "@/services/WarehouseServices.js";
import ReportServices from "@/services/ReportServices.js";

export default {
  getWarehouseList: WarehouseServices.getList,
  getItemData: ReportServices.getItemData,
}